"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseServerEnv = exports.getAllUrls = exports.getPort = exports.getUrl = void 0;

var _urlParse = _interopRequireDefault(require("url-parse"));

var _assert = require("assert");

var _site_list = _interopRequireDefault(require("./site_list"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Get the URL for a site given an environment.
 */
var getUrl = function getUrl(siteName, envSettings) {
  (0, _assert.ok)(envSettings != null, 'envSettings is required');
  (0, _assert.ok)(_typeof(envSettings) === 'object', 'envSettings must be an object');
  var envName = parseServerEnv(envSettings);
  var site = _site_list.default[siteName] != null ? _site_list.default[siteName][envName] : undefined;

  if (site == null) {
    throw new Error("Could not find site ".concat(siteName, " for envSettings ").concat(envName));
  }

  var port = site.port,
      protocol = site.protocol,
      uri = site.uri;
  var boundPort = protocol === 'http' && port != null ? ":".concat(port) : '';
  var path = site.path != null ? site.path : '';
  var url = "".concat(protocol, "://").concat(uri).concat(boundPort).concat(path);
  var useIpAddressForHttpRequests = parseUseIpAddressForHttpRequests(envSettings);
  var serverBind = parseServerBind(envSettings);

  if (useIpAddressForHttpRequests && serverBind != null) {
    var _url = new _urlParse.default(url);

    _url.set('protocol', 'http:');

    _url.set('hostname', serverBind);

    _url.set('port', port);

    url = _url.toString();
  }

  return url;
};
/**
 * Get the port for a site given an environment.
 */


exports.getUrl = getUrl;

var getPort = function getPort(siteName, envSettings) {
  (0, _assert.ok)(envSettings != null, 'envSettings is required');
  (0, _assert.ok)(_typeof(envSettings) === 'object', 'envSettings must be an object');

  if (!_site_list.default.hasOwnProperty(siteName)) {
    throw new Error("Could not find site with name ".concat(siteName));
  }

  var envName = parseServerEnv(envSettings);
  var site = _site_list.default[siteName][envName];
  return site != null ? site.port : undefined;
};
/**
 * Get a list of all site URLs for a given environment. Useful for generating CORS/CSP lists or
 * similar.
 */


exports.getPort = getPort;

var getAllUrls = function getAllUrls(envSettings) {
  (0, _assert.ok)(envSettings != null, 'envSettings is required');
  (0, _assert.ok)(_typeof(envSettings) === 'object', 'envSettings must be an object');
  var siteNames = Object.keys(_site_list.default);
  return siteNames.map(function (site) {
    return getUrl(site, envSettings);
  });
};
/**
 * Get the environment a server is running in based on its environment settings (a combination of
 * `env` and `appInstance`). Throws if the resulting environment is not a valid environment.
 */


exports.getAllUrls = getAllUrls;

var parseServerEnv = function parseServerEnv(envSettings) {
  (0, _assert.ok)(envSettings != null, 'envSettings is required');
  (0, _assert.ok)(_typeof(envSettings) === 'object', 'envSettings must be an object');
  var envName = envSettings.env; // Production and staging both use env=production, but differentiate on appInstance.

  if (envSettings.appInstance === 'staging') {
    envName = 'staging';
  }

  if (envName !== 'development' && envName !== 'test' && envName !== 'staging' && envName !== 'production') {
    throw new Error("Unrecognized environment '".concat(envName, "' (Valid environments: development, production, staging, test)"));
  }

  return envName;
};

exports.parseServerEnv = parseServerEnv;

var parseUseIpAddressForHttpRequests = function parseUseIpAddressForHttpRequests(envSettings) {
  return envSettings.useIpAddressForHttpRequests || false;
};

var parseServerBind = function parseServerBind(envSettings) {
  if (envSettings.server != null && envSettings.server.bind != null) {
    return envSettings.server.bind;
  }

  return null;
};
//# sourceMappingURL=index.js.map